import { createApiClient, type ApiCallParams } from "../api-utils";
import { HttpMethod } from "@/types/https";
import { getWorkchestraOrigin } from "@/lib/utils";

const aerotrak = createApiClient({
  baseURL: `${getWorkchestraOrigin()}/api/aerotrak`,
});

export const apiAerotrakCall = <T>(
  params: Omit<ApiCallParams, "method"> & { method: string }
): Promise<T> => {
  return aerotrak.call<T>({
    ...params,
    method: params.method as HttpMethod,
  });
};

export { HttpMethod };
